import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { Button } from 'reactstrap'
import { Form, Spinner } from 'react-bootstrap'
import { message } from 'antd'

import { storeUnavailableDay } from '../services'
import { handleError } from '../../../helpers'

export default function NewUnavailableDayForm({ reload }) {
	const user = useSelector(state => state.auth.user)
	const { handleSubmit, register, formState: { errors }, reset } = useForm({
		defaultValues: {
			user_id: user.id
		}
	})
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		storeUnavailableDay(values)
			.then(res => {
				message.success(res.data.message)
				setLoading(false)
				reset()
				reload()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<Form.Group className='form-group'>
					<Form.Label>Fecha <span className='text-primary'>*</span></Form.Label>
					<Form.Control 
						{...register('date', { required: true })}
						placeholder='Escriba aquí...'
						type="date"
					/>
					{ errors.date && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text>}
				</Form.Group>
				<Form.Group className='form-group'>
					<Form.Label>Motivo <span className='text-primary'>*</span></Form.Label>
					<Form.Control 
						{...register('reason', { required:true })}
						placeholder='Escriba aquí...'
					/>
					{ errors.reason && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
				</Form.Group>
				<Button color='primary' type="submit" disabled={loading}>
					{ loading && <Spinner animation='border' size="sm" className='mr-5' /> }
					Crear Nuevo Registro
				</Button>
			</Form>
		</React.Fragment>
	)
}